/* eslint-disable no-nested-ternary */
import { Col, Row } from 'antd';

import { useDispatch, useSelector } from 'react-redux';
import {
  actions,
} from 'Slice/IndustriesSlice';
import {
  newsLoading,
  selectedNewsArticles,
  selectNewsPage,
  selectedNewsArticlesEnded,
  selectedNewsFilter,
  selectedPaginationLoading,
  selectNewsIsCall,
  selectNewsFlurryObject,
} from 'Selector/IndustriesSelector';
import { Article } from 'Types/ArticleTypes';
import InfiniteScroll from 'react-infinite-scroll-component';
import ArticleLoadingSkeletonBundle from 'Components/common/skeleton/ArticleLoadingSkeletonBundle';
import { Filter } from 'Types/FilterTypes';
import NoPersonsFound from 'Components/common/components/NoPersonsFound';
import { useEffect } from 'react';
import { actions as flurryActions } from 'Slice/HelperSlice';
import { valueToObject } from 'Utils/UtilityFunctions';
import ArticleListLoadingSkeletonBundle from 'Components/common/skeleton/ArticleListLoadingSkeletonBundle';
import { NODATABASEDONFILTERS } from 'Utils/Constants';
import ArticleGridLayout from 'Components/common/components/ArticleGridLayout';

type Props = {
  id: number;
  listview: boolean;

} & typeof defaultProps;

const defaultProps = {
  id: 0,
  listview: false,

};

const NewsTab = function NewsTab(props: Props) {
  const { id, listview } = props;
  const dispatch = useDispatch();
  const loading: boolean = useSelector(newsLoading);
  const newsArticles: Article[] = useSelector(selectedNewsArticles);
  const page: number = useSelector(selectNewsPage);
  const articleEnded: boolean = useSelector(selectedNewsArticlesEnded);
  const selectedFilters: Filter[] = useSelector(selectedNewsFilter);
  const isPagination = useSelector(selectedPaginationLoading);
  const flurryObject = useSelector(selectNewsFlurryObject);
  const isCalled = useSelector(selectNewsIsCall);

  const fetchArticles = () => {
    const params = {
      page,
      industryId: id,
      ...(selectedFilters.length > 0 && { filters: selectedFilters }),
    };
    dispatch(actions.getNewsActivites(params));
  };

  const fetchMore = () => {
    if (newsArticles.length > 0) {
      fetchArticles();
    }
  };

  useEffect(() => {
    if (Object.keys(flurryObject).length) {
      dispatch(flurryActions.callFlurryEvent(
        valueToObject('industry_news', 0, {
          ...flurryObject,
          isDeleteTime: true,
          ...isCalled && { isCalled },
        }),
      ));
      dispatch(actions.setIsCallNews(true));
    }
  }, [flurryObject]);

  return (
    loading
      ? (
        <Row gutter={[16, 16]} id="tabs-details">
          {listview ? (
            <ArticleListLoadingSkeletonBundle />
          ) : (
            <ArticleLoadingSkeletonBundle />
          )}
        </Row>
      )
      : (
        <>

          <div id="tabs-details">
            <InfiniteScroll
              dataLength={newsArticles.length}
              next={fetchMore}
              hasMore={!articleEnded}
              loader={false}
              className="o-x-hidden o-y-hidden"
            >
              {newsArticles.length > 0
                ? (
                  <ArticleGridLayout
                    isLoading={isPagination}
                    listview={listview}
                    articlesArray={newsArticles}
                  />
                ) : (
                  <Col span={24} className="article-grid width-100">
                    <NoPersonsFound title={NODATABASEDONFILTERS} />
                  </Col>
                )}
            </InfiniteScroll>
          </div>
          {
            isPagination && !articleEnded && (
              <Row gutter={[16, 16]}>
                {listview ? (
                  <ArticleListLoadingSkeletonBundle />
                ) : (
                  <ArticleLoadingSkeletonBundle />
                )}
              </Row>
            )
          }
        </>
      )
  );
};

export default NewsTab;
